import { trackEvent } from "metabase/jerry/Common/jerry-utils";

export type DataCopilotSourceType = "dashboard" | "report";

export interface DataCopilotLaunchSource {
  sourceType: DataCopilotSourceType;
  sourceId: number;
  sourceTitle?: string | null;
  sourceUrl?: string | null;
  entryPoint?: string | null;
  dashcardId?: number | null;
  dashcardName?: string | null;
}

interface DataCopilotLaunchResponse {
  launch_url?: string;
}

function getCurrentUrl() {
  if (typeof window === "undefined") {
    return "";
  }
  return window.location.href;
}

export async function requestDataCopilotLaunchUrl(
  source: DataCopilotLaunchSource,
): Promise<string> {
  const response = await fetch("/api/jerry/data-copilot/launch", {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
    },
    body: JSON.stringify({
      source_type: source.sourceType,
      source_id: source.sourceId,
      source_title: source.sourceTitle ?? undefined,
      source_url: source.sourceUrl || getCurrentUrl(),
      entry_point: source.entryPoint ?? undefined,
      dashcard_id: source.dashcardId ?? undefined,
      dashcard_name: source.dashcardName ?? undefined,
    }),
  });

  const data = (await response.json().catch(() => ({}))) as
    | DataCopilotLaunchResponse
    | { data?: DataCopilotLaunchResponse };
  const launchUrl =
    (data as DataCopilotLaunchResponse)?.launch_url ??
    (data as { data?: DataCopilotLaunchResponse })?.data?.launch_url;
  if (!response.ok || !launchUrl) {
    const fallbackMessage = `Failed to open Data Copilot (${response.status})`;
    throw new Error(fallbackMessage);
  }
  return launchUrl;
}

export function trackDataCopilotLaunch(source: DataCopilotLaunchSource) {
  trackEvent(
    {
      eventLabel: "Open Data Copilot",
    },
    {
      source_type: source.sourceType,
      source_id: source.sourceId,
      source_title: source.sourceTitle,
      source_url: source.sourceUrl || getCurrentUrl(),
      entry_point: source.entryPoint,
      dashcard_id: source.dashcardId,
      dashcard_name: source.dashcardName,
    },
  );
}
